import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import PermissionService from '../services/permission-service';
import AppContext from '../app-context';

/**
 * Use action control service to decide action availability
 *
 * @export
 * @param {*} action Action key defined in iRPM
 * @returns Is action available
 */
export default function useActionControl(action) {
  const { site } = useContext(AppContext);
  const { permissionPrefix } = site;
  const history = useHistory();
  return PermissionService.has(history.location.pathname, action, permissionPrefix);
}
